import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from '../../core/service/layout.service';
import { ReviewService } from '../service/review.service';

@Component({
    templateUrl: './sampling.component.html',
    selector: 'app-sampling',
    styleUrls: ['../list.scss', './review.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SamplingComponent implements OnInit {

  constructor(public layout: LayoutService, private service: ReviewService) { }

  generating = false;
  renewalDate!: string;
  percentage = 2.5;
  @Input() samplings: any[] = [];
  loadingSamplings = false;

  @Output() created = new EventEmitter<string>();

  ngOnInit() {}

  loadSamplings() {
    this.loadingSamplings = true;
    this.service.getSamplings().subscribe(data => {
      this.samplings = data.filter((item: any) => !item.revalidationReviewSamplingId);
      this.loadingSamplings = false;
    });
  }

  generate() {
    this.generating = true;
    this.service.generateSamplings(this.renewalDate, this.percentage).subscribe(() => {
      this.generating = false;
      this.loadSamplings();
      this.created.emit(this.renewalDate);
    });
  }



}
